import GroomingSelfies from "../../services/api/GroomingSelfies";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import qs from "qs";
import Errors from "../../constants/Errors.json";

const handleError = (err) => {
  console.log("[handleError] Error in GroomingSelfies actions", err);
};

export const setGroomingSelfiesList = (payload) => {
  return {
    type: ActionTypes.SET_GROOMING_SELFIES_LIST,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_GROOMING_SELFIES,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_GROOMING_SELFIES,
    payload,
  };
};

export const getGroomingSelfiesList =
  (filters = {}, mappingFilters) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...filters,
      };
      if (filters["start_date"]) {
        finalPayload["start_date"] = filters["start_date"] + "T00:00:00Z";
      }
      if (filters["end_date"]) {
        finalPayload["end_date"] = filters["end_date"] + "T00:00:00Z";
      }
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
        encode: false,
      });
      dispatch(setLoader(true));
      let response = await GroomingSelfies.getGroomingSelfiesList(
        queryParamsString
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setGroomingSelfiesList(response));
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
